import { render, staticRenderFns } from "./StatsProgramSales.vue?vue&type=template&id=fecd87d0&"
import script from "./StatsProgramSales.vue?vue&type=script&lang=js&"
export * from "./StatsProgramSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports